import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { GuestGuard } from 'src/auth/guard';
// layouts
import AuthClassicLayout from 'src/layouts/auth/classic';
// components
import { SplashScreen } from 'src/components/loading-screen';

import ProductPDFPreviewHTML from 'src/pages/public/product-pdf-preview';

import { paths } from '../paths';

// ----------------------------------------------------------------------

// JWT
// const JwtLoginPage = lazy(() => import('src/pages/auth/jwt/login'));

// FIREBASE
const FirebaseLoginPage = lazy(() => import('src/pages/auth/firebase/login'));
const FirebaseForgotPasswordPage = lazy(() => import('src/pages/auth/firebase/forgot-password'));
const FirebaseResetPasswordPage = lazy(() => import('src/pages/auth/firebase/reset-password'));
// ----------------------------------------------------------------------

export const publicRoutes = [
  {
    path: paths.public.productPdfPreview,
    element: <ProductPDFPreviewHTML />,
  },
  {
    path: paths.public.listinoPreview,
    element: <ProductPDFPreviewHTML />,
  },
  {
    path: paths.root,
    element: (
      <GuestGuard>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </GuestGuard>
    ),
    children: [
      {
        path: paths.login,
        element: (
          <AuthClassicLayout>
            <FirebaseLoginPage />
          </AuthClassicLayout>
        ),
      },
      {
        path: paths.forgotPassword,
        element: (
          <AuthClassicLayout>
            <FirebaseForgotPasswordPage />
          </AuthClassicLayout>
        ),
      },
      {
        path: paths.resetPassword,
        element: (
          <AuthClassicLayout>
            <FirebaseResetPasswordPage />
          </AuthClassicLayout>
        ),
      },
    ],
  },
];
